import {Box} from "@mui/material";
import WebTheme from "./WebTheme";
import {RotuloWebMediano} from "./CajasTexto";
import React from "react";




export default function PdfViewer({estilo,pdfArray}) {

    return (
        <Box style={estilo}
             sx={{
                 border: (estilo.background === 'black')?'solid 2px White':WebTheme.borderLines.lineaGreen,
                 width: '80%',
                 ml: '15%',
             }} >
            {pdfArray.length && pdfArray.map((dato, index) => (
                <Box
                    key={index}
                    sx={{ marginBottom: 3, borderRadius: 1, overflow: 'hidden', boxShadow: 2 }} >
                    <RotuloWebMediano estiloPagina= {estilo} texto={dato.name} marginLeft={'auto'} marginBottom={'5px'}></RotuloWebMediano>
                    <iframe
                        src = {dato.url}
                        title={`Documento PDF ${index + 1}`}
                        width="100%"
                        height="800px"
                        style={{ border: "none" }}
                    />
                </Box>
            ))}
            {!pdfArray.length && <Box>
                <RotuloWebMediano estiloPagina= {estilo} texto={"No hay documentos vigentes"} marginLeft={'auto'} marginBottom={'5px'}></RotuloWebMediano>
            </Box>
            }
        </Box>
    );
}
